import { Inventory } from "../../inventary/inventory"
import Stocks from "../../stocks/stocks"

export const InventoryReport=()=>{
return (<Stocks gridSize={{
        sm:6,
        xs:12
      }} />)
}